import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';
import {
  Card,
  CardContent,
  Grid,
  Paper,
} from '@material-ui/core';
import { 
  renderMultiLineTextField,
  renderTextField,
  renderSelectField6
} from '../../../form-global-components/components-form-components-for-react-final-form';
import {
  NA_YES_NO,
  NO_YES,
  RESIDENT_WITH_DISABILITIES,
  CLIENT_IDENTIFIED_SEXUAL_ORIENTATION,
  CLIENT_RECIDIVISM_RISK_SCORE_LEVEL,
                                                  // UNKNOWN_YES_NO,
} from '../../../../actions/action-constants';
class FormFieldsIntakeAssessRiskFactorsIntake extends Component {
  buildOptions_DrugScreenScore () {
    var options = []
    options.push({
      value: '0',
      label: "N / A"
    })
    for (let i = 1; i <= 11; i++) {
      options.push({
        value: '' + i,
        label: i
      })
    }
    return options
  }
  render () {
    return (
      <div>

        <Paper>
          <Card>
            <CardContent>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={NO_YES}
                    id='clientrisktoselfothers'
                    name='clientrisktoselfothers'
                    label='Client Risk to Self / Others'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    locked={this.props.locked}
                    component={renderMultiLineTextField}
                    id='clientrisktoselfotherscomment'
                    name='clientrisktoselfotherscomment'
                    label='Client Risk to Self / Others Comment'
                    rows='6'
                    emptyText='Please be aware of HIPAA laws and concerns. Enter only what is required, nothingg more that is not permitted by law.'
                    footerMessage='Please be aware of HIPAA laws and concerns. Enter only what is required, nothing more that is not permitted by law.'
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={RESIDENT_WITH_DISABILITIES}
                    id='residentwithdisabilities'
                    name='residentwithdisabilities'
                    label='Resident with Disabilities'
                    footerMessage=''
                    />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={CLIENT_IDENTIFIED_SEXUAL_ORIENTATION}
                    id='clientidentifiedsexualorientation'
                    name='clientidentifiedsexualorientation'
                    label='Client Identified Sexual Orientation'
                    footerMessage=''
                    />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                                        ////  LOCATED IN BOTH TAB-CLIENT-CONDITIONS AND HERE SAME FIELD
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                                          // dataArray={UNKNOWN_YES_NO}
                    dataArray={NA_YES_NO}
                    id='clientriskofvictimization'
                    name='clientriskofvictimization'
                    label='Client Risk of Victimization'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={NA_YES_NO}
                    id='clientriskasperpetrator'
                    name='clientriskasperpetrator'
                    label='Client Risk As Perpetrator'
                    footerMessage=''
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={this.buildOptions_DrugScreenScore()}
                    id='drugscreenscore'
                    name='drugscreenscore'
                    label='Drug Screen Score'
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    locked={this.props.locked}
                    component={renderTextField}
                    id='clientrecidivismriskscorenumber'
                    name='clientrecidivismriskscorenumber'
                    label='Client Recidivism Risk Score'
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    autoFocus
                    component={renderSelectField6}
                    locked={this.props.locked}
                    dataArray={CLIENT_RECIDIVISM_RISK_SCORE_LEVEL}
                    id='clientrecidivismriskscorelevel'
                    name='clientrecidivismriskscorelevel'
                    label='Client Recidivism Risk Score Level'
                    footerMessage=''
                    />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    locked={this.props.locked}
                    component={renderMultiLineTextField}
                    id='clientintakeandassessmentcomments'
                    name='clientintakeandassessmentcomments'
                    label='Client Intake and Assessment Comment'
                    rows='6'
                    emptyText='Please be aware of HIPAA laws and concerns. Enter only what is required, nothingg more that is not permitted by law.'
                    footerMessage='Please be aware of HIPAA laws and concerns. Enter only what is required, nothingg more that is not permitted by law.'
                  />
                </Grid>
              </Grid>

            </CardContent>
          </Card>
        </Paper>
      </div>
    )
  }
}
FormFieldsIntakeAssessRiskFactorsIntake.propTypes = {
  locked: PropTypes.bool,
  programSelected: PropTypes.string
}
export default FormFieldsIntakeAssessRiskFactorsIntake
